import React from "react";

export const Cloud = ({ className = "" }) => (
  <svg viewBox="0 0 320 120" aria-hidden="true" className={`block ${className}`}>
    <path
      fill="currentColor"
      d="M46 92c0-20 16-34 38-34 6-16 22-28 42-28 16 0 30 8 38 20 8-6 16-8 26-8 22 0 40 16 44 36 14 2 26 14 26 30 0 16-14 30-32 30H76c-18 0-30-12-30-46z"
    />
  </svg>
);

export const CloudSoft = ({ className = "" }) => (
  <svg viewBox="0 0 240 90" aria-hidden="true" className={`block ${className}`}>
    <path
      fill="currentColor"
      d="M30 70c0-16 12-28 28-28 4-12 16-22 32-22 12 0 22 6 28 16 6-4 14-6 22-6 18 0 32 12 34 28 12 2 20 12 20 22 0 14-12 24-26 24H52c-14 0-22-10-22-34z"
    />
  </svg>
);
